module.exports = __webpack_public_path__ + "static/media/armor-circle-logo.49813a01.svg";